export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=40595014f79d697173fef52ffa149f0b5294c05a83&name=revalidateCommunity!'